module.exports = __webpack_public_path__ + "img/bar-tab.61559145.svg";